import { formElementHelper, formHelper, FormSchema } from '@jht/react-library';

export const contactPersonFormSchema = (options, values): FormSchema => {
  const optionsMap = options.map((opt, i) => {
    return opt.inputNames.map((inputName, index) => {
      const isEmailInput = inputName === 'email';
      return formElementHelper({
        fullWidth: true,
        col: 3,
        name: `contact_${i + '_' + inputName}`,
        label: opt.inputLabels[index],
        value: values[`contact_${i + '_' + inputName}`]
          ? values[`contact_${i + '_' + inputName}`]
          : '',
        inputType: 'input',
        type: isEmailInput ? 'email' : 'text',
        validation: isEmailInput ? { isEmail: true } : null,
        validationMessages: isEmailInput
          ? {
              isEmail: 'Email Address Invalid',
            }
          : null,
      });
    });
  });

  const elements = [];
  optionsMap.forEach(option => {
    option.forEach(item => {
      elements.push(item);
    });
  });
  return formHelper(elements);
};
